<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.studentRankActivityDeletedList.push"
  >
    <el-table-column label="ID" prop="id" width="70"/>
    <el-table-column label="活动名称" prop="activity_name" width="240"/>
    <el-table-column label="统计区间" width="240">
      <template v-slot="{ row }">
        {{ row.start_time | timeToYmdHi }} ~ {{ row.end_time | timeToYmdHi }}
      </template>
    </el-table-column>
    <el-table-column label="上榜人数" prop="student_count" width="110"/>
    <el-table-column label="已发券人数" prop="issued_count" width="120"/>
    <v-column-time value="删除时间" field="is_del" sortable=""/>
    <el-table-column label="操作" width="140">
      <template v-slot="{ row }">
        <v-list-button
          name="恢复"
          icon="restore"
          @click="handleRestore(row)"
          :is-loading="isRestoring[row.id]"
          message="确定要恢复此活动吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`student-rank-activity-deleted-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>活动名称</span>
              <span>{{ v.activity_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>统计区间</span>
              <span>{{ v.start_time | timeToYmdHi }} ~ {{ v.end_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.is_del | timeToYmdHi }}</span>
            </div>

            <div class="list-item-button">
              <v-list-button
                name="恢复"
                icon="restore"
                @click="handleRestore(v)"
                :is-loading="isRestoring[v.id]"
                message="确定要恢复此活动吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { index, restore } from '@/api/student-rank-activity';

export default {
  name: RouteConfig.studentRankActivityDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isRestoring: {},
    count: 0,
    list: [],
    queryList: {
      is_del: 1,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route) {
      this.isLoading = true;
      getLegalQueryList(this.queryList, route.query);
      const { isError, data } = await index(this.queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count || 0;
      this.list = data.list || [];
    },
    async handleRestore({ id, update_time }) {
      if (!id || !Number.isInteger(update_time)) {
        return this.$message.warning('缺少活动信息，无法还原！');
      }

      this.isRestoring = { ...this.isRestoring, [id]: true };
      const { isError } = await restore(id, { update_time });
      this.isRestoring = { ...this.isRestoring, [id]: false };
      if (isError) return;

      this.$message.success('还原成功');
      this.load();
    },
  },
};
</script>
